let accountAddress = process.env.REACT_APP_EVENTIO_API_ADDRESS || 'https://account-api.eventio.fi';
let backendAddress = process.env.REACT_APP_ARPAMAAILMA_BACKEND_ADDR || 'https://arpamaailma.fi';
let cmsUrl = process.env.REACT_APP_CMS_URL || 'https://sbhdiag215.blob.core.windows.net/arpamaailma-static/cms.json';
let customJSUrl = process.env.REACT_APP_CUSTOM_JS_URL || 'https://sbhdiag215.blob.core.windows.net/arpamaailma-static/am-custom.js';
let gtmId = 'GTM-K8MMDSD';
let nuorelleSiivetOnly = false;
let nuorelleSiivetSlug = 'nuorelle-siivet';
let oauth2SettingsAuthority = process.env.REACT_APP_AUTH_ADDR || 'https://auth.eventio.fi/';
let oauth2ClientId = process.env.REACT_APP_AUTH_CLIENT_ID || 'arpamaailma.fi';
let strongAuthUrl = process.env.REACT_APP_STRONG_AUTH_URL || 'https://tunnistus.telia.fi/uas/oauth2/authorization';
let strongAuthClientId = process.env.REACT_APP_STRONG_AUTH_CLIENT_ID || '48907d73-5ff8-4888-8b21-dc2c58128a42';

switch (window.location.origin) {
    case 'https://arpamaailma-local-dev':
    case 'https://localhost:3000':
    case 'https://127.0.0.1:3000':
        accountAddress = process.env.REACT_APP_EVENTIO_API_ADDRESS || 'https://account-api.dev.eventio.fi';
        backendAddress = process.env.REACT_APP_ARPAMAAILMA_BACKEND_ADDR || 'https://dev.arpamaailma.fi';
        cmsUrl = process.env.REACT_APP_CMS_URL || 'https://sbhdiag215.blob.core.windows.net/arpamaailma-testing/cms.json';
        customJSUrl = process.env.REACT_APP_CUSTOM_JS_URL || 'https://sbhdiag215.blob.core.windows.net/arpamaailma-testing/am-custom.js';
        gtmId = '';
        nuorelleSiivetOnly = process.env.REACT_APP_NUORELLE_SIIVET || false;
        oauth2SettingsAuthority = process.env.REACT_APP_AUTH_ADDR || 'https://auth.dev.eventio.fi/';
        strongAuthUrl = process.env.REACT_APP_STRONG_AUTH_URL || 'https://tunnistus-pp.telia.fi/uas/oauth2/authorization';
        strongAuthClientId = process.env.REACT_APP_STRONG_AUTH_CLIENT_ID || 'c4b9859f-252a-4374-8f59-a160349ec0f0';
        nuorelleSiivetSlug = 'nuorelle-siivet-arpa';
        break;

    case 'https://dev.arpamaailma.fi':
        accountAddress = 'https://account-api.dev.eventio.fi';
        backendAddress = 'https://dev.arpamaailma.fi';
        cmsUrl = 'https://sbhdiag215.blob.core.windows.net/arpamaailma-testing/cms.json';
        customJSUrl = 'https://sbhdiag215.blob.core.windows.net/arpamaailma-testing/am-custom.js';
        gtmId = 'GTM-PR7HZGB';
        oauth2SettingsAuthority = 'https://auth.dev.eventio.fi/';
        strongAuthUrl = 'https://tunnistus-pp.telia.fi/uas/oauth2/authorization';
        strongAuthClientId = 'c4b9859f-252a-4374-8f59-a160349ec0f0';
        nuorelleSiivetSlug = 'nuorelle-siivet-arpa';
        break;

    case 'https://lunastus.nuorellesiivet.fi':
        cmsUrl = 'https://v89k0.upcloudobjects.com/eventio-group-nuorelle-siivet-production/cms.json';
        customJSUrl = 'https://v89k0.upcloudobjects.com/eventio-group-nuorelle-siivet-production/am-custom.js';
        backendAddress = 'https://api.lunastus.nuorellesiivet.fi';
        nuorelleSiivetOnly = true;
        oauth2ClientId = 'lunastus.nuorellesiivet.fi';
        break;

    case 'https://dev.lunastus.nuorellesiivet.fi':
        accountAddress = 'https://account-api.dev.eventio.fi';
        backendAddress = 'https://api.dev.lunastus.nuorellesiivet.fi';
        cmsUrl = 'https://v89k0.upcloudobjects.com/eventio-group-nuorelle-siivet-testing/cms.json';
        customJSUrl = 'https://v89k0.upcloudobjects.com/eventio-group-nuorelle-siivet-testing/am-custom.js';
        nuorelleSiivetOnly = true;
        oauth2ClientId = 'lunastus.nuorellesiivet.fi';
        oauth2SettingsAuthority = 'https://auth.dev.eventio.fi/';
        strongAuthUrl = 'https://tunnistus-pp.telia.fi/uas/oauth2/authorization';
        strongAuthClientId = 'c4b9859f-252a-4374-8f59-a160349ec0f0';
        nuorelleSiivetSlug = 'nuorelle-siivet-arpa';
        break;
}

const config = {
    accountAddress: accountAddress,

    backendAddress: backendAddress,

    cms: {
        url: cmsUrl
    },

    customJS: {
        url: customJSUrl
    },

    beacon: {
        id: 'c7448749-4760-44bc-8e33-e066c60e3f1f'
    },

    gtm: {
        id: gtmId,
    },

    playableTicketsEnabled: false,

    nuorelleSiivetOnly: nuorelleSiivetOnly,
    nuorelleSiivetSlug: nuorelleSiivetSlug,

    oauth2_settings: {
        authority: oauth2SettingsAuthority,
        client_id: oauth2ClientId,

        redirect_uri: `${window.location.origin}/callback`,
        post_logout_redirect_uri: `${window.location.origin}`,
        response_type: 'code',
        scope: 'openid profile email phone address offline',
        loadUserInfo: true,
        mergeClaims: true,
    },

    strong_auth_settings: {
        auth_url: strongAuthUrl,
        client_id: strongAuthClientId,
        redirect_uri: `${window.location.origin}/auth`,
        response_type: 'code',
        scope: 'openid',
    }
};

export default config;
